@if (shouldShowBanner()) {
<section
  class="cookie-banner"
  aria-live="polite"
>
  <div class="cookie-banner__inner">
    <div class="cookie-banner__content">
      <p class="cookie-banner__eyebrow">{{ 'layout.cookies.eyebrow' | translate }}</p>
      <h2 class="cookie-banner__title">{{ 'layout.cookies.title' | translate }}</h2>
      <p class="cookie-banner__description">{{ 'layout.cookies.description' | translate }}</p>

      <a
        class="cookie-banner__policy-link"
        routerLink="/politica-de-cookies"
      >
        {{ 'layout.cookies.policyLink' | translate }}
      </a>

      <div class="cookie-banner__categories">
        <article class="cookie-banner__category cookie-banner__category--required">
          <div class="cookie-banner__category-head">
            <h3 class="cookie-banner__category-title">
              {{ 'layout.cookies.categories.essential.title' | translate }}
            </h3>
            <span class="cookie-banner__category-badge">
              {{ 'layout.cookies.categories.essential.badge' | translate }}
            </span>
          </div>
          <p class="cookie-banner__category-description">
            {{ 'layout.cookies.categories.essential.description' | translate }}
          </p>
        </article>

        <article class="cookie-banner__category">
          <div class="cookie-banner__category-head">
            <h3 class="cookie-banner__category-title">
              {{ 'layout.cookies.categories.analytics.title' | translate }}
            </h3>

            <app-switch
              [checked]="analyticsEnabled()"
              [label]="'layout.cookies.categories.analytics.title'"
              (checkedChange)="onAnalyticsChange($event)"
            />
          </div>
          <p class="cookie-banner__category-description">
            {{ 'layout.cookies.categories.analytics.description' | translate }}
          </p>
        </article>
      </div>
    </div>

    <div class="cookie-banner__actions">
      <app-button
        variant="secondary"
        (click)="acceptEssentialOnly()"
      >
        {{ 'layout.cookies.actions.essentialOnly' | translate }}
      </app-button>

      <app-button
        variant="secondary"
        (click)="savePreferences()"
      >
        {{
          (hasDecision()
            ? 'layout.cookies.actions.savePreferences'
            : 'layout.cookies.actions.saveSelection'
          ) | translate
        }}
      </app-button>

      <app-button
        variant="primary"
        (click)="acceptAll()"
      >
        {{ 'layout.cookies.actions.acceptAll' | translate }}
      </app-button>
    </div>
  </div>
</section>
}
